var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgOutsiteLink = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#116069",
    width: 20.5,
    height: 20.5,
    viewBox: "0 0 20.5 20.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "full-screen",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2890",
    "data-name": "Group 2890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2889",
    "data-name": "Group 2889"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77462",
    "data-name": "Path 77462",
    d: "M108.379,0V2.222h3.983L101.44,13.144l1.572,1.572L113.934,3.794V7.778h2.222V0Z",
    transform: "translate(-96.157)",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77463",
    "data-name": "Path 77463",
    d: "M17.778,17.778H2.222V2.222H10V0H2.222A2.222,2.222,0,0,0,0,2.222V17.778A2.222,2.222,0,0,0,2.222,20H17.778A2.222,2.222,0,0,0,20,17.778V10H17.778Z",
    stroke: "#fff",
    strokeWidth: 0.5
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOutsiteLink, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/outsite-link.2165abe8.svg";
export { ForwardRef as ReactComponent };